import { useEffect } from 'react';
import useGoTo from 'src/hooks/useGoTo';
import useUserStore from 'src/stores/user';
import { ROUTES_URL } from 'src/constants/routes';

import PaymentScreen from '../Payment';

export default function Payment() {
    const goTo = useGoTo();
    const currentSubscription = useUserStore(({ current_subscription }) => current_subscription);
    const isOnboardingCompleted = useUserStore(({ isOnboardingCompleted }) => isOnboardingCompleted);

    // Если подписка активна и онбординг завершен - переходим на Feed с параметром успешной оплаты
    useEffect(() => {
        if (currentSubscription?.is_active && isOnboardingCompleted) {
            goTo(`${ROUTES_URL.FEED}?payment_success=true`);
        }
    }, [currentSubscription?.is_active, isOnboardingCompleted, goTo]);

    return <PaymentScreen />;
}
